import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export function postProblemAnswer(problemId: any, answerObj: any) {
    const { apiPostProblemAnswer } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostProblemAnswer}${problemId}/`, { answer: JSON.stringify(answerObj) });
}
